export default "__VITE_ASSET__DZMSAPDV__"